<div class="centering-container sign-in-instruction">
    <svg xmlns="http://www.w3.org/2000/svg" width="128.45" height="141.515" viewBox="0 0 128.497 141.515">
        <use href="/assets/unilever-logo.svg#logo" fill="#fff"/>
    </svg>

    <div class="flex-bottom">
        <span class="center">Accelerated by</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="261.817" height="66.893" viewBox="0 0 261.817 66.893">
            <use href="/assets/mclaren-logo.svg#logo-white"/>
        </svg>
    </div>
</div>